/* eslint-disable max-len */
const CrossIcon = ({ colorTheme }: {colorTheme: string}) => {

  const svg = `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.33594 9.33398L22.6693 22.6673" stroke="${colorTheme}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.33594 22.6673L22.6693 9.33398" stroke="${colorTheme}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export default CrossIcon;
